/* eslint-disable @typescript-eslint/no-restricted-imports */
import { defineConfig } from 'cva';
import { extendTailwindMerge } from 'tailwind-merge';

export { type VariantProps } from 'cva';

export const twMerge = extendTailwindMerge({
  prefix: 'tw-',
});

export const { cva, cx, compose } = defineConfig({
  hooks: {
    onComplete: (className) => twMerge(className),
  },
});
